module.exports = __webpack_public_path__ + "static/gamechangers-637d4fecc5a63b9b1b04ec21163dc644.png";